const newsletter = () => ({
  email: '',
  message: '',
  loading: false,

  subscribe: async function () {
    this.loading = true
    this.message = ''
    try {
      const response = await fetch('https://palefire.myshopify.com/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          'form_type': 'customer',
          'utf8': '✓',
          'contact[email]': this.email,
          'customer[accepts_marketing]': 'true'
        })
      })

      if (!response.ok) {
        console.error('Failed to subscribe:', response)
        throw new Error('Failed to subscribe with Shopify')
      }

      this.message = 'Subscription successful via Shopify!'
      this.email = ''
    } catch (error) {
      this.message = error.message || 'An error occurred. Please try again.'
    } finally {
      this.loading = false
    }
  }
})

export default newsletter
